"use client";

import { createElement, useEffect } from "react";

export const PrivacyPolicyDataId = "416bc7a2-dbda-493b-a5ae-e5caf9de5581";
export const CookiePolicyDataId = "47252197-f3d4-4bb3-b57f-6601b9279606";
export const TermsAndConditionsPolicyDataId =
  "8dde529a-57cd-43ff-8b0c-2bd68ce13374";

export const TermlyPolicy = ({ dataId }: { dataId: string }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return createElement("div", {
    name: "termly-embed",
    "data-id": dataId,
    "data-type": "iframe",
  });
};
